module.exports = "<div class=\"widget\" *ngIf=\"loggedIn\">\r\n  <h5>{{ greeting }}</h5>\r\n</div>\r\n"